module.exports = __webpack_public_path__ + "media/components/assets/img/bg/circle-shape-tl-dashboard-fae2dde97929b1f4d1df5413ef9bf85b.svg";